<template>
  <div class="revenue-table card">
    <div class="card-header bg-white">
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="{active: activeTab === 'product'}" @click="activeTab = 'product'" href="#">Theo sản phẩm</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{active: activeTab === 'category'}" @click="activeTab = 'category'" href="#">Theo danh mục</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{active: activeTab === 'user'}" @click="activeTab = 'user'" href="#">Theo nhân viên</a>
        </li>
      </ul>
    </div>
    <div class="card-body p-0">
      <div v-if="activeTab === 'product'" class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="thead-light">
            <tr>
              <th>Sản phẩm</th>
              <th class="text-center">Số lượng</th>
              <th class="text-right">Doanh thu</th>
              <th class="text-right">Giá vốn</th>
              <th class="text-right">Lợi nhuận</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in reportByProduct" :key="item.productId">
              <td>{{ item.productName }}</td>
              <td class="text-center">{{ item.quantitySold }}</td>
              <td class="text-right">{{ item.revenue.toLocaleString() }}₫</td>
              <td class="text-right">{{ item.cost.toLocaleString() }}₫</td>
              <td class="text-right font-weight-bold" :class="item.profit >= 0 ? 'text-success' : 'text-danger'">
                {{ item.profit.toLocaleString() }}₫
              </td>
            </tr>
            <tr v-if="!reportByProduct.length">
              <td colspan="5" class="text-center py-4 text-muted">Không có dữ liệu trong khoảng thời gian này</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="activeTab === 'category'" class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="thead-light">
            <tr>
              <th>Danh mục</th>
              <th class="text-right">Doanh thu</th>
              <th class="text-right">Giá vốn</th>
              <th class="text-right">Lợi nhuận</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in reportByCategory" :key="item.categoryId">
              <td>{{ item.categoryName }}</td>
              <td class="text-right">{{ item.revenue.toLocaleString() }}₫</td>
              <td class="text-right">{{ item.cost.toLocaleString() }}₫</td>
              <td class="text-right font-weight-bold" :class="item.profit >= 0 ? 'text-success' : 'text-danger'">
                {{ item.profit.toLocaleString() }}₫
              </td>
            </tr>
            <tr v-if="!reportByCategory.length">
              <td colspan="4" class="text-center py-4 text-muted">Không có dữ liệu trong khoảng thời gian này</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="activeTab === 'user'" class="table-responsive">
        <table class="table table-hover mb-0">
          <thead class="thead-light">
            <tr>
              <th>Nhân viên</th>
              <th class="text-center">Số đơn hàng</th>
              <th class="text-right">Doanh thu</th>
              <th class="text-right">Lợi nhuận ước tính</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in reportByUser" :key="item.userId">
              <td>{{ item.userName }}</td>
              <td class="text-center">{{ item.totalOrders }}</td>
              <td class="text-right">{{ item.revenue.toLocaleString() }}₫</td>
              <td class="text-right font-weight-bold text-success">{{ item.profit.toLocaleString() }}₫</td>
            </tr>
            <tr v-if="!reportByUser.length">
              <td colspan="4" class="text-center py-4 text-muted">Không có dữ liệu trong khoảng thời gian này</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RevenueTable',
  props: {
    reportByProduct: Array,
    reportByCategory: Array,
    reportByUser: Array
  },
  data() {
    return {
      activeTab: 'product'
    };
  }
};
</script>

